import React, { Component } from 'react';
import Cookies from "universal-cookie";
import './ipcalc.css'
import {Host} from '../../../config/config'

class Ipcalc extends Component {


  constructor(props){
    super(props)
    // this.Getnetsinfo=this.Getnetsinfo.bind(this)
    this.state  = {
      isFetching:true,
      range:'',
    }
  }


componentDidMount(){


  const cookies = new Cookies();

  // fetch('http://'+this.props.host+'/api/datauser/',
  fetch('http://'+Host+'/api/ocnitIpcalc/',

        {
      method: 'POST',
      headers: new Headers({
               'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
               'Access-Control-Allow-Origin': '*',
      }),

      body: "author="+cookies.get('sidd')+"&mode=ip_calc&nets="+this.props.nets // <-- Post parameters

        }    )
        .then((response)=>response.json())
    //      .then((nets)=>this.setState({cnet:nets[0]['net']}))
          .then((calc)=>this.setState({range:calc}))


}


render() {

    return (
              <div style={{'background':'#ebeef9'}}>
                <div style={{'text-align':'right', 'cursor':'pointer'}}><a href={null} onClick={this.props.closenetwin}>(X)</a></div>
                <div className="calcname">&nbsp;&nbsp;&nbsp;&nbsp;<b>Настройки для сети {this.props.nets}</b></div>
                <div className="calc">
                  <div></div>
                  <div> <b><i>Адрес Шлюза:</i></b> {this.state.range[2]}</div>
                  <div> <b><i>IP Адреса:</i></b> с {this.state.range[0]} по {this.state.range[1]}</div>
                  <div> <b><i>Маска подсети:</i></b> {this.state.range[3]}</div>
                  <div> <b><i>Proxy(при необходимости):</i></b> proxy.tsu.tula.ru, порт 3128</div>

                </div>
              </div>
            )
      }

}
export default Ipcalc;
